exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.select-user li[data-v-1897b636]{ width: 30px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_supplier/src/views/coupon/coupon/SendCoupon.vue"],"names":[],"mappings":";AACA,kCAAkC,YAAY;CAC7C","file":"SendCoupon.vue","sourcesContent":["\n.select-user li[data-v-1897b636]{ width: 30px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1897b636","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/coupon/coupon/SendCoupon.vue
// module id = 62h7
// module chunks = 0